import { ApplicationState } from "../../store";
import { getLocaleTextForSnackBarPopup } from "../../store/LanguageLocale/selector";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { SnackBarPopup } from "./SnackBarPopup.component";
import { ISnackBarPopupMapStateProps, ISnackBarPopupMapDispatchProps } from "./Types";
import { getShowSnackBarVisibility } from "../../store/SnackBarPopup/selectors";
import { toggleSnackBarPopupVisibility } from "../../store/SnackBarPopup/actions";

const mapStateToProps = (state: ApplicationState): ISnackBarPopupMapStateProps => {
    return {
        show: getShowSnackBarVisibility(state.snackBarPopUp),
        text: getLocaleTextForSnackBarPopup(state.localeText)
    };
}

const mapDispatchToProps = (dispatch: Dispatch): ISnackBarPopupMapDispatchProps=> ({
    onDismiss: () => {
        dispatch(toggleSnackBarPopupVisibility(false));
    }
});

export default connect<ISnackBarPopupMapStateProps, ISnackBarPopupMapDispatchProps, void> (mapStateToProps, mapDispatchToProps)(SnackBarPopup);


// WEBPACK FOOTER //
// ./src/components/SnackBarPopup/SnackBarPopup.container.ts